import L from "leaflet";

import "leaflet/dist/leaflet.css";

document.addEventListener("DOMContentLoaded", () => {
  const mapElement = document.querySelector("#map");
  if (!mapElement) return;

  const lat = parseFloat(mapElement.dataset.lat);
  const lng = parseFloat(mapElement.dataset.lng);
  const popupText = mapElement.dataset.popup || "We are here!";

  const icon = L.icon({
    iconUrl: "./assets/icons/location-dot-solid.svg",
    iconSize: [30, 80],
    iconAnchor: [22, 94],
    shadowAnchor: [4, 62],
    popupAnchor: [-3, -76],
  });

  const map = L.map("map", {
    maxZoom: 16,
    scrollWheelZoom: false,
    touchZoom: false,
    dragging: window.innerWidth > 768,
    tap: window.innerWidth > 768,
  }).setView([lat, lng], 14);

  L.tileLayer(
    "https://services.arcgisonline.com/arcgis/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}"
  ).addTo(map);

  L.tileLayer(
    "https://{s}.basemaps.cartocdn.com/light_only_labels/{z}/{x}/{y}.png"
  ).addTo(map);

  L.marker([lat, lng], { icon }).addTo(map).bindPopup(popupText).openPopup();
});
